import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    /**
     * 当前用户目前的企业实体，当一个用户有多家公司，同一时间他只能在系统中激活其中一家
     */
    currentEnterprise: undefined,
    /**
     * 当前登录用户的id
     */
    userId: undefined
  },
  mutations: {
    currentEnterprise(state, val) {
      state.currentEnterprise = val
    },
    userId(state, val) {
      state.userId = val
    },
  },
  getters: {
    currentEnterprise(state) {
      return state.currentEnterprise
    },
    userId(state) {
      return state.userId
    },
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js